import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// Languages
import en from './languages/en';

const resources = { en };

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    load: 'unspecific',
    ns: ['translations'],
    defaultNS: 'translations',

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true,
    },
  });

export function t(name, params = {}) {
  return i18n.t(name, params);
}

export function getLanguages() {
  return Object.keys(resources);
}

export function getCurrentLang() {
  const languages = getLanguages();
  const lng = i18n.language;

  return languages.includes(lng) ? lng : 'en';
}

export default i18n;
